import {
  MenuRoot,
  MenuContent,
  MenuItem,
  ButtonIcon,
  MenuTrigger,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { Typography } from 'shared/components/Typography';

type TJournalRepliesCardHeaderMenu = {
  onEdit: () => void;
  onDelete: () => void;
};

export const JournalRepliesCardHeaderMenu = ({
  onEdit,
  onDelete,
}: TJournalRepliesCardHeaderMenu) => (
  <MenuRoot>
    <MenuTrigger>
      <ButtonIcon aria-label="Options" variant="ghost" size="sm">
        <Icon name={iconNames.ellipsis} />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent portalled={false}>
      <MenuItem
        //@ts-ignore
        onClick={onEdit}
      >
        Edit
      </MenuItem>
      <MenuItem
        //@ts-ignore
        onClick={onDelete}
      >
        <Typography color="red">Delete</Typography>
      </MenuItem>
    </MenuContent>
  </MenuRoot>
);
